export * from './file-types';
export * from './generic';
export * from './social';

export type { IconComponentType } from './types';
